// extracted by mini-css-extract-plugin
export default {"SpotifyLoginBtn":"SpotifyLogin_SpotifyLoginBtn__5aIUz","LogoutText":"SpotifyLogin_LogoutText__IfoNj"};